module.exports = __webpack_public_path__ + "static/img/map1.bdc97876.png";